import React from "react";
import TableTemplate from "./Table";
import CardLayout from "../Cards/CardLayout";
import { COLORS } from "../../utils/constants";
import { useUtils } from "../../customHooks/useUtils";

const data = {
  results: [
    {
      site: "Segbaya 1",
      subscription: "Paid",
      date: "2021-09-01 12:00:00",
      amount_billed: "Oshodi",
      amount_bought: "District A",
      duration: "2 days",
    },
    {
      site: "Segbaya 2",
      subscription: "Paid",
      date: "2021-09-01 12:00:00",
      amount_billed: "Oshodi",
      amount_bought: "District A",
      duration: "2 days",
    },
    {
      site: "Segbaya 3",
      subscription: "Pending",
      date: "2021-09-01 12:00:00",
      amount_billed: "Oshodi",
      amount_bought: "District A",
      duration: "2 days",
    },
  ],
};

const columns = [
  "Site",
  "Subscription",
  "Date/Time",
  "Amount Billed",
  "Amount Bought",
  "Duration",
];
const tableData = data.results.map((item) => {
  return {
    Site: item.site,
    Subscription: item.subscription,
    "Date/Time": item.date,
    "Amount Billed": item.amount_billed,
    "Amount Bought": item.amount_bought,
    Duration: item.duration,
  };
});
const TransactionHistoryTable = () => {
  const { t } = useUtils();
  const styleCell = (value: string | number, column: string) => {
    if (column === "Subscription") {
      return {
        color: value === "Paid" ? "green" : COLORS.RED,
        fontWeight: "bold",
      };
    }
    return {};
  };

  return (
    <CardLayout
      title="Transaction History"
      className="lg:min-w-[550px] flex-1"
      besideTitleComponent={
        <div className="text-sm h-6 flex items-center justify-center rounded-sm p-2 min-w-[50px] bg-primary-yellowMain">
          {t("feedback.dummy_data")}
        </div>
      }
    >
      <TableTemplate
        data={tableData}
        columns={columns}
        styleCell={styleCell}
        totalCount={20}
        page={1}
        onPageChange={(page) => console.log(page)}
      />
    </CardLayout>
  );
};
export default TransactionHistoryTable;
